/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Button, Popover } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

interface IAccountCustomerBalanceActions {
    className?: string;
    requestStatementButtonLabel: string;
    onRequestStatement(): void;

}

interface IAdminRequestStatementProps {
    className?: string;
    requestStatementButtonLabel: string;
    myUserAccountLabel: string;
    fullOrganizationLabel: string;
    isDropdownShowing: boolean;
    onToggleDropdown(): void;
    onRequestStatement(isFullOrg: boolean): void;
}

export const ActionBar: React.FC<IAccountCustomerBalanceActions> = ({ className, onRequestStatement, requestStatementButtonLabel }) => {
    return (
        <div className={className}>
                <Button className={`${className}__action__requestStatement`} onClick={onRequestStatement}>
                    {requestStatementButtonLabel}
                </Button>
            </div>
        );
};

export const AdminRequestStatementButton: React.FC<IAdminRequestStatementProps> = ({ className, onRequestStatement, requestStatementButtonLabel, onToggleDropdown, myUserAccountLabel, fullOrganizationLabel, isDropdownShowing}) => {
    const onSelectCustomerAccount = (e: React.MouseEvent<HTMLButtonElement>) => {
        onRequestStatement(false);
    };

    const onSelectFullOrg = (e: React.MouseEvent<HTMLButtonElement>) => {
        onRequestStatement(true);
    };

    const popoverRef = React.createRef<HTMLButtonElement>();

    return (
        <div className={`${className}__dropdown`}>
            <Button className={isDropdownShowing ? `${className}__action__requestStatement__toggleUp` : `${className}__action__requestStatement__toggleDown`} onClick={onToggleDropdown} innerRef={popoverRef}>
                <span className={`${className}__action__requestStatement__buttonLabel`}>
                    {requestStatementButtonLabel}
                </span>
            </Button>
            <Popover className={`${className}__action__requestStatement__dropdownVisible`} isOpen={isDropdownShowing} placement='bottom' target={popoverRef} toggle={onToggleDropdown}>
                <Button onClick={onSelectCustomerAccount} className={`${className}__action__requestStatement__dropdownOption`}>
                    {myUserAccountLabel}
                </Button>
                <Button onClick={onSelectFullOrg} className={`${className}__action__requestStatement__dropdownOption`}>
                    {fullOrganizationLabel}
                </Button>
            </Popover>
        </div>
        );
};